import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as api from "./tagApi";

export const fetchTags = createAsyncThunk("tag/fetchTags", async (_, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getTags({}, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch tags");
  }
});

export const createTag = createAsyncThunk("tag/createTag", async (data, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.createTag(data, token);
    toast.success("Tag created successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to create tag";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const updateTag = createAsyncThunk("tag/updateTag", async ({ id, data }, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.updateTag(id, data, token);
    toast.success("Tag updated successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to update tag";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const deleteTag = createAsyncThunk("tag/deleteTag", async (id, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    await api.deleteTag(id, token);
    toast.success("Tag deleted successfully");
    return id;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to delete tag";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

const tagSlice = createSlice({
  name: "tag",
  initialState: { tags: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTags.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload?.tags || action.payload || [];
      })
      .addCase(fetchTags.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(createTag.fulfilled, (state, action) => {
        const tag = action.payload?.tag || action.payload;
        if (tag?._id) state.tags.push(tag);
      })
      .addCase(createTag.rejected, (state, action) => { state.error = action.payload; })

      .addCase(updateTag.fulfilled, (state, action) => {
        const tag = action.payload?.tag || action.payload;
        if (tag?._id) {
          const idx = state.tags.findIndex((t) => t._id === tag._id);
          if (idx !== -1) state.tags[idx] = tag;
        }
      })
      .addCase(updateTag.rejected, (state, action) => { state.error = action.payload; })

      .addCase(deleteTag.fulfilled, (state, action) => {
        state.tags = state.tags.filter((t) => t._id !== action.payload);
      })
      .addCase(deleteTag.rejected, (state, action) => { state.error = action.payload; });
  },
});

export default tagSlice.reducer;
